"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var statuses_1 = require("./consts/statuses");
var defaultConfig_1 = require("./helpers/defaultConfig");
var resultsAnalyzing_1 = require("./helpers/resultsAnalyzing");
var safetlyCall_1 = require("./helpers/safetlyCall");
var Cmeter = /** @class */ (function () {
    function Cmeter(_config) {
        var _this = this;
        this.busy = false;
        this.checks = [];
        this.status = [];
        // Events
        this.onStepFinish = function () { return ({}); };
        this.onTestingFinish = function () { return ({}); };
        this.onStatusUpdate = function () { return ({}); };
        this.onTestFail = function () { return ({}); };
        this.bindEvents = function (events) {
            var _a, _b, _c, _d;
            _this.onStepFinish = (_a = events.onStepFinish) !== null && _a !== void 0 ? _a : _this.onStepFinish;
            _this.onTestingFinish = (_b = events.onTestingFinish) !== null && _b !== void 0 ? _b : _this.onTestingFinish;
            _this.onStatusUpdate = (_c = events.onStatusUpdate) !== null && _c !== void 0 ? _c : _this.onStatusUpdate;
            _this.onTestFail = (_d = events.onTestFail) !== null && _d !== void 0 ? _d : _this.onTestFail;
        };
        this.callOnStepFinish = function (index) {
            (0, safetlyCall_1.tryToCall)(function () {
                _this.onStepFinish(_this.getStatus()[index]);
            });
        };
        this.callOnTestingFinish = function () {
            (0, safetlyCall_1.tryToCall)(function () {
                _this.onTestingFinish(__spreadArray([], _this.getStatus(), true));
            });
        };
        this.callOnStatusUpdate = function () {
            (0, safetlyCall_1.tryToCall)(function () {
                _this.onStatusUpdate(__spreadArray([], _this.getStatus(), true));
            });
        };
        this.callOnTestFail = function () {
            (0, safetlyCall_1.tryToCall)(function () {
                _this.onTestFail(__spreadArray([], _this.getStatus(), true));
            });
        };
        this.updateCheckStatus = function (index, newStatus) {
            if (index < 0 || index > _this.status.length)
                return;
            _this.status[index] = __assign(__assign({}, _this.status[index]), newStatus);
            _this.callOnStatusUpdate();
        };
        this.updateAllStatuses = function (newStatus) {
            _this.status.forEach(function (__, index, array) {
                array[index] = __assign(__assign({}, array[index]), newStatus);
            });
            _this.callOnStatusUpdate();
        };
        this.replaceStatusStageValues = function (oldStage, newStage) {
            _this.status.forEach(function (element, index, array) {
                if (element.stage === oldStage) {
                    array[index].stage = newStage;
                }
            });
            _this.callOnStatusUpdate();
        };
        this.registerComponent = function (name, component, resources) {
            if (resources === void 0) { resources = []; }
            if (_this.busy) {
                throw "You can't register new components while cmeter instance is busy! To get cmeters status call cmeter.getStatus()";
            }
            if (_this.isComponentNameTaken(name)) {
                throw new Error("Component name must be unique! Component with name \"" + name + "\" already exists.");
            }
            _this.status.push({
                name: name,
                componentIndex: _this.checks.length,
                stage: statuses_1.STATUS_SLEEP,
                testResults: [],
                passed: false,
            });
            _this.checks.push({
                checkComponent: component,
                name: name,
                resources: resources,
            });
            _this.callOnStatusUpdate();
        };
        this.enterTestMode = function () {
            _this.busy = true;
            _this.updateAllStatuses({ stage: statuses_1.STATUS_QUEUED, testResults: [] });
        };
        this.exitTestMode = function () {
            _this.busy = false;
        };
        this.start = function () { return __awaiter(_this, void 0, void 0, function () {
            var checksArray, _i, checksArray_1, _a, index, check, CheckComponent, resources, checkInstance, testResults, passed;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.busy)
                            throw new Error("Cmeter is currently running!");
                        this.enterTestMode();
                        checksArray = Array.from(this.checks.entries());
                        _i = 0, checksArray_1 = checksArray;
                        _b.label = 1;
                    case 1:
                        if (!(_i < checksArray_1.length)) return [3 /*break*/, 4];
                        _a = checksArray_1[_i], index = _a[0], check = _a[1];
                        CheckComponent = check.checkComponent, resources = check.resources;
                        this.updateCheckStatus(index, { stage: statuses_1.STATUS_TESTING });
                        checkInstance = new CheckComponent();
                        return [4 /*yield*/, checkInstance.beginTest(resources)];
                    case 2:
                        testResults = _b.sent();
                        passed = !(0, resultsAnalyzing_1.didTestFailed)(testResults);
                        this.updateCheckStatus(index, {
                            stage: passed ? statuses_1.STATUS_TESTED : statuses_1.STATUS_FAILED,
                            testResults: testResults,
                            passed: passed,
                        });
                        this.callOnStepFinish(index);
                        if (!passed) {
                            this.callOnTestFail();
                            return [3 /*break*/, 4];
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.callOnTestingFinish();
                        this.exitTestMode();
                        return [2 /*return*/];
                }
            });
        }); };
        var config = __assign(__assign({}, defaultConfig_1.defaultConfig), _config);
        config.checks.forEach(function (_a) {
            var name = _a.name, checkComponent = _a.checkComponent, _b = _a.resources, resources = _b === void 0 ? [] : _b;
            _this.registerComponent(name, checkComponent, resources);
        });
        // Events should be binded after components registration
        this.bindEvents(config.events);
        this.callOnStatusUpdate();
    }
    Cmeter.prototype.getStatus = function () {
        return this.status;
    };
    Cmeter.prototype.isBusy = function () {
        return this.busy;
    };
    Cmeter.prototype.isComponentNameTaken = function (name) {
        return !!this.checks.find(function (element) {
            return element.name === name;
        });
    };
    return Cmeter;
}());
exports.default = Cmeter;
